<template>
    <section>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <app-favourite-item :favouritesDetails="favouritesDetails"></app-favourite-item>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import FavouriteItem from '../components/FavouriteItem.vue';

    export default {
        data() {
            return {
                favouritesDetails: []
            }
        },
        methods: {
            removeFirebaseDataChild(verse) {
                document.getElementById(verse).remove();
                db.collection(this.$store.getters.getUserId).doc(verse).delete().then(() => {
                    console.log("Document deleted!");
                }).catch(function(error) {
                    console.log("Error removing document: ", error);
                });
            },
            checkUserLoggedIn() {
                auth.onAuthStateChanged( user => {
                    if (user) {
                        if (!this.$store.getters.getFavouritesLoadedState) {
                            this.loadFirebaseData();
                        } else {
                            this.favouritesDetails = this.$store.getters.getFavouritesDetails;
                        }
                    } 
                    else {
                        if (this.$store.getters.getFavouritesDetails != null) {
                            this.favouritesDetails = this.$store.getters.getFavouritesDetails;
                        }
                    }
                });
            },
            loadFirebaseData() {
                db.collection(this.$store.getters.getUserId).get().then(querySnapshot => {
                    let allFavourites = [];
                    querySnapshot.forEach(doc => {
                        // doc.data() is never undefined for query doc snapshots
                        // console.log(doc.id, " => ", doc.data());
                        allFavourites.push(doc.data());
                    })
                    this.$store.dispatch('setFavouritesDetails', allFavourites); 
                    this.favouritesDetails = allFavourites;
                    this.$store.dispatch('setFavouritesLoadedState', true);
                }).catch(function(error) {
                    console.log("Error getting document:", error);
                });
            }
        },
        components: {
            appFavouriteItem: FavouriteItem
        },
        created() {
            this.$store.dispatch('updateCurrentPage','favourites');
            this.checkUserLoggedIn();
            // console.log(this.$store.getters.getFavouritesLoadedState);
        }
    }
</script>


// WEBPACK FOOTER //
// src/views/Favourites.vue